import React from "react";
import TablaExpendedor from "../components/agentes/tablaExpendedor";

function Expendedores() {
  return (
    <div className="col-md-12 d-flex justify-content-center m-0 p-0">
      <TablaExpendedor />
    </div>
  );
}

export default Expendedores;



// WEBPACK FOOTER //
// ./src/pages/expendedores.js